import { createContext } from "react";

export const NavigationContext = createContext(null);